<template>
  <div class="avatars">
    <ul class="avatars__accordion" uk-accordion>
      <li class="">
        <a class="uk-accordion-title" href="#">Список уровней</a>
        <div class="uk-accordion-content">
          <ul class="statuses">
            <li v-for="st in items" :key="st.id" :class="(user.status && user.status.id == st.id) ? 'active' : ''">
              <div class="statuses__num">{{st.sort_order }}.</div>
              <div class="statuses__title">{{ st.title }}</div>
              <div class="statuses__scores uk-visible@m" uk-tooltip="Столько баллов нужно набрать чтобы перейти на этот уровень">{{ st.scores_from}}</div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "status_table",
  data() {
    return {
      items: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  inject: ['http'],
  methods: {
    async getStatuses() {
      this.items = await this.http.post('onGetStatuses').then(res => res.data);
    }
  },
  async mounted() {
    await this.user
    this.getStatuses();
  }
}
</script>